import { reveal } from '../modules/scroll-reveal';

window.addEventListener('load', event => {
	reveal('.js-reveal');
});
